import { render, staticRenderFns } from "./savePermission.vue?vue&type=template&id=000394e8&"
import script from "./savePermission.vue?vue&type=script&lang=js&"
export * from "./savePermission.vue?vue&type=script&lang=js&"
import style0 from "./savePermission.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports